export default {
  toasts: {
    load_error: 'Betalingsopsætningen kunne ikke indlæses',
    rails_saved: 'Betalingsspor gemt',
    gateway_registered: 'Gateway registreret',
    redact_failed: 'Gatewayen kunne ikke slettes',
    gateway_redacted: 'Gateway slettet',
    sca_provisioned: '3DS2-registrering oprettet',
    company_assigned: 'Restaurant tildelt',
    default_set: 'Standardgateway angivet – nye restauranter tildeles den automatisk',
    default_failed: 'Standardgatewayen kunne ikke angives',
    primary_switched: 'Primær gateway skiftet til {{gateway}}',
    primary_switch_failed: 'Den primære gateway kunne ikke skiftes',
  },
  custody: {
    title: 'Hvem behandler betalinger',
    description:
      "Fastlægges én gang ved den første lagring af betalingsspor og låses derefter: Med egen gateway modtager partneren pengene; på FoodAmigos' Adyen-konto modtager FoodAmigos dem og udbetaler partnerens andel månedligt.",
    options: {
      provider: 'Partnerens egen gateway',
      platform: 'FoodAmigos behandler betalinger',
    },
    locked_notice: 'Låst til „{{custodian}}“ af betalingskonfigurationen – kan ikke ændres.',
    pick_first: 'Vælg først, hvem der behandler betalinger.',
    lock_confirm: {
      title: 'Lås betalinger til „{{custodian}}“?',
      description:
        'Hvis du gemmer nu, afgøres det, hvem der modtager partnerens midler, og det kan ikke fortrydes – hverken her eller af support. Betalingssporet kan stadig ændres senere; hvem der behandler betalingerne, kan ikke.',
      confirm: 'Lås og gem',
    },
  },
  rails: {
    title: 'Betalingsspor',
    description:
      'Hvilken betalingsudbyder partneren bruger – kun én ad gangen. Restauranter kan kun skiftes til det valgte spor, og et spor kan ikke erstattes, mens restauranter stadig betaler via det.',
    save: 'Gem spor',
    multiple_warning:
      'Denne partner kører stadig på mere end ét spor ({{rails}}). Når du gemmer, beholdes kun det valgte ovenfor; resten fjernes, og ændringen afvises helt, hvis en restaurant stadig betaler via et af dem.',
    options: {
      stripe: 'Stripe',
      adyen: 'Adyen',
      spreedly: 'Lokal gateway via Spreedly',
    },
    platform_stripe_unavailable: 'Stripe på FoodAmigos-kontiene er ikke tilgængelig endnu.',
    platform_custody_notice: 'Ikke tilgængelig, når FoodAmigos behandler betalingerne.',
    provider_custody_adyen_notice:
      "Ikke tilgængelig, når partneren bruger sin egen gateway – Adyen er FoodAmigos' behandlingsspor.",
  },
  spreedly_section_title: 'Spreedly-opsætning',
  gateways: {
    title: 'Gateways',
    description: 'Partnerens egne PSP-konti. Hele betalingen afvikles til den valgte gateways acquirer.',
    register: 'Registrer gateway',
    empty: 'Ingen gateways registreret endnu',
    columns: {
      gateway: 'Gateway',
      status: 'Status',
      sca: '3DS2',
      companies: 'Restauranter',
    },
    statuses: {
      active: 'Aktiv',
      redacted: 'Slettet',
    },
    sca: {
      sandbox: '3DS2-sandbox',
      live: '3DS2 live',
      none: 'Ingen 3DS2',
    },
    default_tag: 'Standard',
    actions: {
      make_default: 'Gør til standard',
      check: 'Kør tjek…',
      sca_provision: 'Opsæt 3DS2…',
      sca_manage: '3DS2-registrering…',
      redact: 'Slet gateway',
    },
  },
  redact_confirm: {
    title: 'Slet {{gateway}}?',
    description:
      'Legitimationsoplysningerne slettes hos Spreedly og kan ikke gendannes. {{count}} tildelt(e) restaurant(er) betaler stadig via denne gateway – så længe nogen er tildelt, afvises sletningen, og du bliver bedt om at bekræfte igen.',
    redact: 'Slet',
    force_title: 'Slet {{gateway}} alligevel?',
    force_description:
      '{{count}} restaurant(er) er stadig tildelt denne gateway. Hvis den slettes nu, afvises deres checkout, indtil hver af dem er tildelt en anden gateway. Dette kan ikke fortrydes.',
    force_redact: 'Slet alligevel',
  },
  companies: {
    title: 'Restauranter',
    description: 'Hvilken udbyder hver restaurant betaler via, og dens Spreedly-gatewaytildeling.',
    empty: 'Ingen restauranter',
    no_gateway: 'Ingen',
    unassigned: 'Ikke tildelt',
    // The default gateway is assigned at creation and never fails the creation —
    // so a restaurant can end up unassigned with the reason only in the log.
    assignment_error_label: 'Automatisk tildeling mislykkedes',
    assign: 'Tildel',
    reassign: 'Tildel igen',
    columns: {
      restaurant: 'Restaurant',
      primary_gateway: 'Primær gateway',
      spreedly: 'Spreedly-gateway',
    },
    switch_primary_to: 'Skift til {{gateway}}',
    assign_modal: {
      title: 'Tildel {{company}} til en gateway',
      assign: 'Tildel',
      gateway: 'Gateway',
      make_primary: 'Gør også Spreedly til primær gateway',
      make_primary_hint: 'Betalinger går kun via Spreedly, når det er den primære gateway.',
    },
  },
  register_modal: {
    title: 'Registrer en gateway',
    register: 'Registrer',
    gateway_type: 'Gatewaytype',
    gateway_type_placeholder: 'Søg i Spreedlys katalog…',
    auth_mode: 'Godkendelsestilstand',
    no_credentials: 'Denne gatewaytype kræver ingen legitimationsoplysninger (Spreedly-sandbox).',
    description: 'Beskrivelse',
    description_placeholder: 'f.eks. Acme Eats – Braintree EUR',
    acquirer_merchant_id: 'Acquirer-forhandler-ID',
    acquirer_hint: 'Valgfrit – kræves sammen med MCC',
    mcc: 'MCC',
    mcc_hint: '4 cifre, f.eks. 5812',
    make_default: 'Brug som partnerens standard',
    make_default_hint:
      'Partnerens nye restauranter og dem uden en gateway endnu bindes til den. Lad feltet være tomt, hvis det er én restaurants egen acquirer.',
  },
  sca_modal: {
    title: '3DS2-registrering – {{gateway}}',
    provision: 'Opsæt',
    irreversible_warning:
      'Uigenkaldeligt: Hverken forhandlerprofilen eller SCA-udbyderen kan redigeres eller slettes bagefter. En forkert acquirer-BIN opdages først ved betaling. Kontrollér alle værdier hos den indløsende bank, før du opsætter.',
    already_provisioned:
      'Allerede opsat (udbydertoken {{token}}). Ny opsætning returnerer den eksisterende registrering, medmindre Genopret er aktiveret.',
    type: {
      label: 'Udbydertype',
      hint: '„Test“ simulerer godkendelsesresultater og afvises i produktion.',
      test: 'Test (SCA-sandbox)',
      live: 'Live (Spreedly 3DS2 Global)',
    },
    country: {
      hint: 'Det land, den indløsende bank har registreret denne forhandler under – ikke nødvendigvis, hvor partneren er registreret. Gælder for alle kortnetværk nedenfor.',
      differs_warning:
        'Dette er ikke partnerens land ({{country}}). Ret det, hvis acquireren har registreret forhandleren et andet sted; ellers kontrollér det, da en forhandlerprofil ikke kan redigeres efter oprettelsen.',
    },
    network_placeholder: 'Kortnetværk',
    add_network: 'Tilføj kortnetværk',
    networks: {
      visa: 'Visa',
      mastercard: 'Mastercard',
      amex: 'American Express',
      discover: 'Discover',
      diners: 'Diners',
      jcb: 'JCB',
      dankort: 'Dankort',
      union_pay: 'UnionPay',
      cartes_bancaires: 'Cartes Bancaires',
    },
    fields: {
      acquirer_merchant_id: 'Acquirer-forhandler-ID',
      acquirer_bin: 'Acquirer-BIN',
      mcc: 'MCC',
      merchant_name: 'Forhandlernavn',
      country_code: 'Land (ISO-2)',
      merchant_url: 'Forhandler-URL',
    },
    recreate: {
      label: 'Genopret registreringen',
      hint: 'Opgiver den nuværende forhandlerprofil og SCA-udbyder for altid og opretter nye.',
    },
  },
  check_modal: {
    title: 'Tjek gateway – {{gateway}}',
    run: 'Kør tjek',
    done: 'Færdig',
    failed: 'Tjekket kunne ikke køres.',
    types: {
      verify: 'Verificér (ingen penge flyttes)',
      test_payment: 'Testbetaling',
    },
    verify_unsupported: 'Denne gatewaytype understøtter ikke verificering – kør i stedet en testbetaling.',
    test_payment_warning:
      'Der opkræves et reelt beløb på en live-gateway, som straks refunderes. På gateways i SCA-markeder kan udstederen afvise testbetalingen uden 3DS – det beviser stadig, at legitimationsoplysningerne nåede frem til acquireren.',
    amount: 'Beløb',
    amount_help: 'Mellem 1,00 og 5,00',
    check_passed: 'Kontrol bestået',
    check_failed: 'Kontrol mislykkedes – se trinnene nedenfor',
    legs: {
      verify: 'Verifikation',
      purchase: 'Opkrævning',
      credit: 'Refundering',
    },
    leg_passed: 'Bestået',
    leg_failed: 'Mislykkedes',
  },
  card_fields: {
    script_failed: 'Spreedly-scriptet kunne ikke indlæses. Tjek netværket, og prøv igen.',
    full_name: 'Kortholders navn',
    number: 'Kortnummer',
    expiry: 'Udløb',
    cvv: 'CVV',
  },
};
